import GLOBAL from "../GLOBAL";
import { token } from "../config/access-token";

class MainModel {
  directEndpointFetch = (endpoint, data) =>
    fetch(endpoint, {
      method: data.method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      //mode: 'no-cors',
      body: data.body,
    })
      .then((response) => response.json().then((e) => e))
      .catch((error) => ({ require: false, data: [], error }));

  authEndpointFetch = async (endpoint, data) => {
    let check_school = "";
    if (localStorage.getItem("check_school_table_uuid") == "") {
      check_school = localStorage.getItem("check_school_table_uuid", "");
    } else {
      check_school = localStorage.getItem("check_school_table_uuid");
    }
    let check_academic_year = "";
    let check_year_term = "";
    if (localStorage.getItem("check_academic_year_table_uuid") == "") {
      check_academic_year = localStorage.getItem(
        "check_academic_year_table_uuid",
        ""
      );
      check_year_term = localStorage.getItem("check_year_term", "");
    } else {
      check_academic_year = localStorage.getItem(
        "check_academic_year_table_uuid"
      );
      check_year_term = localStorage.getItem("check_year_term");
    }
    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": token["x-access-token"],
        school_table_uuid: localStorage.getItem("school_table_uuid"),
        school_in_group: localStorage.getItem("school_in_group"),
        check_academic_year_table_uuid: localStorage.getItem(
          "check_academic_year_table_uuid"
        ),
        check_school_table_uuid: check_school,
        check_academic_year_table_uuid: check_academic_year,
        check_year_term: check_year_term,
      },
      body: data.body,
    })
      .then((response) => response.json().then((e) => e))
      .catch((error) => ({ require: false, data: [], error }));

    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }

    return response;
  };

  authUploadFile = async (endpoint, data) => {
    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        "x-access-token": token["x-access-token"],
      },
      body: data.body,
    })
      .then((response) => response)
      .then((result) => result)
      .catch((error) => console.log("error", error));

    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }
    return response;
  };

  authParamsUploadFile = async (endpoint, data) => {
    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        "x-access-token": token["x-access-token"],
      },
      body: data.body,
    })
      .then((response) => response)
      .then((result) => result)
      .catch((error) => console.log("error", error));

    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }
    return response;
  };

  authDeleteUploadFile = async (endpoint, data) => {
    const response = await fetch(endpoint, {
      method: data.method,
      headers: {
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        "x-access-token": token["x-access-token"],
      },
      body: data.body,
    })
      .then((response) => response)
      .then((result) => result)
      .catch((error) => console.log("error", error));

    if (response.unauthorized) {
      console.log("unauthorized", response.error);
      localStorage.clear();
      window.location.reload();
    }
    return response;
  };

  authUploadImageFile = async ({ url, method, body }) => {
    const isFormData = body instanceof FormData;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          "x-access-token": token["x-access-token"],
        },
        body,
      });

      const result = await response.json(); // ✅ fetch ต้องใช้ .json()
      return result;
    } catch (error) {
      console.error("API Error:", error);
      return { require: false, data: [], error };
    }
  };

  authParamsUploadFileImage = async ({ url, method, body }) => {
    try {
      const isFormData = body instanceof FormData;
      const fetchBody = isFormData ? body : JSON.stringify(body);
      const response = await fetch(url, {
        method,
        headers: {
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          "x-access-token": token["x-access-token"],
        },
        body: fetchBody,
      });
      const result = await response.json();
      if (!result.require || !result.files) return [];
      return result.files.map((f) => {
        const byteCharacters = atob(f.buffer);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new File([byteArray], f.file_name, { type: f.mime_type });
      });
    } catch (error) {
      console.error("authParamsUploadFileImage API Error:", error);
      return [];
    }
  };
}

export class BaseFetch extends MainModel {
  directFetch = (data) =>
    this.directEndpointFetch(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authFetch = (data) =>
    this.authEndpointFetch(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authUpload = (data) =>
    this.authUploadFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authUploadImage = (data) =>
    this.authUploadImageFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, data);
  authParamsUpload = (data) =>
    this.authParamsUploadFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, {
      method: data.method,
      body: data.body,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json()) // ได้ JSON ที่มี array
      .then((result) => {
        if (!result.require) return [];

        return result.files.map((f) => {
          // แปลง base64 -> Uint8Array -> File
          const byteCharacters = atob(f.buffer);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          return new File([byteArray], f.file_name, { type: f.mime_type });
        });
      })
      .catch((error) => console.log("error", error));

  authDeleteUpload = (data) =>
    this.authDeleteUploadFile(`${GLOBAL.BASE_SERVER.URL}${data.url}`, {
      method: data.method,
      body: data.body,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response)
      .then((e) => e)
      .catch((error) => console.log("error", error));

  authDeleteUpload = (data) =>
    this.authDeleteUploadFile(
      `${GLOBAL.BASE_SERVER.URL}${data.url}/${data.body}`,
      { method: data.method }
    )
      .then((response) => response)
      .then((e) => e)
      .catch((error) => console.log("error", error));

  authParamsUploadFileImageFetch = (data) =>
    this.authParamsUploadFileImage({
      url: `${GLOBAL.BASE_SERVER.URL}${data.url}`,
      method: data.method,
      body: data.body,
    });
}
